import { defineStore } from 'pinia';

export const useBannersStore = defineStore('banners', {
    state: () => ({
        popupBillboards: [],
        showPopupBillboards: true,
    }),

    actions: {
        setPopupBillboards(popupBillboards) {
            const banners = [...popupBillboards];

            for (const banner of banners) {
                banner.isDialogOpen = true;
            }

            this.popupBillboards = banners;

            // Check if we should let these banners be visible.
            const showPopupBillboards = localStorage.getItem('showPopupBillboards');
            if (showPopupBillboards === null) return;

            // @Note: In the localStorage boolean values are stored as strings.
            this.showPopupBillboards = showPopupBillboards === 'true';
        },

        setShowPopupBillboards(bool) {
            this.showPopupBillboards = bool;

            localStorage.setItem('showPopupBillboards', this.showPopupBillboards);
        },

        showPopupBillboardsExists() {
            return localStorage.getItem('showPopupBillboards') !== null;
        },

        tryInitializeShowPopupBillboards(value) {
            if (!this.showPopupBillboardsExists()) {
                this.setShowPopupBillboards(value);
            }
        },
    },
});
